import { moderateScale } from '../../../utils/scaleHelpers';

export const TOGGLE_CONTAINER_WIDTH = moderateScale(33);
export const TOGGLE_SWITCH_SIDE_LENGTH = moderateScale(21);
export const SLIDE_VALUE = TOGGLE_CONTAINER_WIDTH - TOGGLE_SWITCH_SIDE_LENGTH;
